import BezierEasing from 'bezier-easing/dist/bezier-easing.min.js';

export class AnimationModule {
	static animate(draw, {
		timing = EasingFunctions.linear,
		duration = 300,
		delay,
		complete
	} = {}) {
		const perform = () => {
			let start = performance.now();

			requestAnimationFrame(function animate(time) {
				const diff = (time - start) < 0 ? 0 : (time - start);
				let timeFraction = diff / duration;
				if (timeFraction > 1) timeFraction = 1;

				let progress = timing(timeFraction);

				draw(progress);

				if (timeFraction < 1) {
					requestAnimationFrame(animate);
				} else {
					if (complete && typeof complete === 'function') {
						complete();
					}
				}
			});
		};

		if (delay && typeof delay === 'number') {
			setTimeout(perform, delay);
		} else {
			perform();
		}
	}

	static fadeIn(
		$element,
		options = {}
	) {
		let { display = 'block', duration = 300, ease = 'primary', delay, complete } = options;
		let timing;

		switch (ease) {
			case 'linear':
				timing = EasingFunctions.linear;
			case 'primary':
				timing = EasingFunctions.primary;
			case 'easeInCubic':
				timing = EasingFunctions.easeInCubic;
			case 'easeOutCubic':
				timing = EasingFunctions.easeOutCubic;
			case 'easeInOutCubic':
				timing = EasingFunctions.easeInOutCubic;
		}

		$element.style.display = display;
		AnimationModule.animate((progress) => {
			$element.style.opacity = progress;
		}, {
			timing, duration, delay, complete
		});
	}

	static fadeOut(
		$element,
		options = {}
	) {
		let { duration = 300, ease = 'primary', delay, complete } = options;
		let timing;

		switch (ease) {
			case 'linear':
				timing = EasingFunctions.linear;
			case 'primary':
				timing = EasingFunctions.primary;
			case 'easeInCubic':
				timing = EasingFunctions.easeInCubic;
			case 'easeOutCubic':
				timing = EasingFunctions.easeOutCubic;
			case 'easeInOutCubic':
				timing = EasingFunctions.easeInOutCubic;
		}

		AnimationModule.animate((progress) => {
			$element.style.opacity = 1 - progress;
		}, {
			timing, duration, delay,
			complete: () => {
				$element.style.display = 'none';

				if (complete && typeof complete === 'function') {
					complete();
				}
			}
		});
	};

	static initAnimationStopper() {
		let resizeTimer;
		window.addEventListener("resize", () => {
			document.body.classList.add("resize-animation-stopper");
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				document.body.classList.remove("resize-animation-stopper");
			}, 400);
		});
	}
}

export class EasingFunctions {
	static bezier(x1 = 0, y1 = 0, x2 = 0, y2 = 0) {
		return BezierEasing(x1, y1, x2, y2);
	}

	static primary(t) {
		const easing = EasingFunctions.bezier(0.32, 0.08, 0.24, 1);
		return easing(t);
	}

	static linear(t) {
		return t;
	}

	static easeInCubic(t) {
		return t*t;
	}

	static easeOutCubic(t) {
		return (--t)*t*t+1;
	}

	static easeInOutCubic(t) {
		return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
	}
}